import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { Components } from '@npm-bbta/bbog-dig-dt-webcomponents-lib';
import { IUserStorage } from '../../models/userStorage';
import { StorageService } from '../../services/storage/storage.service';
import { Customer } from '../../models/customer';

@Component({
  selector: 'app-drawer',
  templateUrl: './drawer.component.html',
  styleUrls: ['./drawer.component.scss'],
})
export class DrawerComponent implements AfterViewInit {
  @ViewChild('summaryDrawer') summaryDrawer!: ElementRef<Components.BdbMlDrawer>;
  @Input() sendLinks!: () => Promise<void>;
  @Output() close = new EventEmitter<void>();
  @Input() product: string;
  @Input() customer: Customer;
  informationLoading: boolean = true;
  userStorage: IUserStorage;
  advisor: {
    idNumber: string;
    costCenter: string;
  };

  constructor(private readonly storageService: StorageService) {
    this.advisor = {
      idNumber: '',
      costCenter: '000000000 VALOR QUEMADO',
    };
  }

  ngAfterViewInit(): void {
    this.summaryDrawer.nativeElement.openDrawer();
    const { identificationNumber } = this.storageService.getUser();
    this.advisor = {
      ...this.advisor,
      idNumber: identificationNumber,
    };
    setTimeout(() => {
      this.informationLoading = false;
    }, 5000);
    this.customer = {
      ...this.customer,
      costCenter: 'Premium VALOR QUEMADO',
    };
  }
  drawerContinue(): void {
    if (this.sendLinks) {
      this.sendLinks();
    }
  }

  closeDrawer(): void {
    this.summaryDrawer.nativeElement.closeDrawer();
    this.close.emit();
  }
}
